import { ElevationScroll } from "./ElevationScroll";
import React, { useEffect, useRef, useMemo } from "react";
import { Box } from "@mui/material";
import { observer } from "mobx-react";
import { getFloatingBar } from "./floatingBar";
import useMeasure from "react-use-measure";

type GridExpressProps = {
  drawerWidth: number;
  barTop: number;
  closedDrawerWidth: number;
  sideBarOpen: boolean;
  updateHeight: (size: number | undefined) => void; // La recibe, pero no la usa
  children?: React.ReactElement | React.ReactElement[];
};

const boxAppMargins = 0;

export const ToolBar: React.FC<GridExpressProps> = observer(
  ({
    drawerWidth,
    sideBarOpen,
    barTop,
    closedDrawerWidth,
    updateHeight,
    children,
  }) => {
    const [measureRef, bounds] = useMeasure();
    const lastReportedHeight = useRef<number | undefined>();

    useEffect(() => {
      const currentHeight = bounds.height;
      if (currentHeight > 0 && currentHeight !== lastReportedHeight.current) {
        updateHeight(currentHeight);
        lastReportedHeight.current = currentHeight;
      } else if (
        lastReportedHeight.current !== undefined &&
        currentHeight <= 0
      ) {
        updateHeight(0);
        lastReportedHeight.current = 0;
      }
    }, [bounds.height, updateHeight]);

    const FloatingBar = useMemo(
      () => getFloatingBar(closedDrawerWidth, drawerWidth, boxAppMargins),
      [closedDrawerWidth, drawerWidth]
    );

    // Renderizado mínimo
    return (
      <ElevationScroll>
        <FloatingBar
          style={{ marginTop: barTop }}
          position="fixed"
          open={sideBarOpen}
          color={"default"}
        >
          <Box sx={{ ml: 2 }} ref={measureRef}>
            {children}
          </Box>
        </FloatingBar>
      </ElevationScroll>
    );
  }
);
